$(function(){
  $('.pagecollection .tt-collapse').each(function(){
    var ttLis = $(this).find('.tt-list-row li');
    if(ttLis.length > 5){
      ttLis.each(function(i){
        if(i > 4){
          $(this).addClass('hide').addClass('extra-filters');
        }
      });
      ttLis.parent().append('<a class="more-filter" href="#">Show More</a>');
    }
  });

  $('.pagecollection .tt-collapse').on('click', '.more-filter', function(e){
    e.preventDefault();
    console.log('morefilter');
    if(!$(this).hasClass('less')){
      $(this).parent().find('li.extra-filters').removeClass('hide');
      $(this).addClass('less');
      $(this).text('Show Less');
    }else{
      $(this).parent().find('li.extra-filters').addClass('hide');
      $(this).removeClass('less');
      $(this).text('Show More');
    }
  });
});